import React, { useEffect, useRef, useState } from "react";
import { FormikProps, FormikValues } from "formik";

import { SubmissionButtons } from "./components/SubmissionButtons";
import { InputFields } from "./components/InputFields";

interface NotificationSettingsProps extends FormikProps<FormikValues> {
  handleClose: any;
  handleGoBackBtn: any;
  activeStep: any;
  isLastStep: any;
  isFormLoading: any;
}

export const NotificationSettings: React.FC<NotificationSettingsProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
  setFieldValue,
  handleClose,
  handleGoBackBtn,
  activeStep,
  isLastStep,
  isFormLoading,
  setFieldError,
  setFieldTouched
}) => {
  return (
    <div className="flex flex-col justify-start items-start w-full bg-bgWhite pb-4 rounded-lg dark:bg-secondaryLight">
      <div className="relative flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 bg-bgWhite rounded-lg dark:bg-secondaryLight">
        <div className="px-1 w-full">
          <InputFields
            handleChange={handleChange}
            handleBlur={handleBlur}
            values={values}
            errors={errors}
            touched={touched}
            setFieldError={setFieldError}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
          />
        </div>

        <SubmissionButtons
          handleClose={handleClose}
          handleGoBackBtn={handleGoBackBtn}
          handleSubmit={handleSubmit}
          activeStep={activeStep}
          values={values}
          isFormLoading={isFormLoading}
          isLastStep={isLastStep}
        />
      </div>
    </div>
  );
};

// import { DayCheckbox } from "./components/DayCheckbox";
// import { Formik, Form, Field } from "formik";

// interface Day {
//   name: string;
//   value: string;
// }
